import { useTranslation } from 'react-i18next';
import { Input, InputTypeMap } from '../Input';
import { RangeFilterContainer, Separator } from './styled';

interface RangeFilterProps {
  minName: string;
  minId: string;
  maxName: string;
  maxId: string;
}

export const RangeFilter = ({
  minName,
  minId,
  maxId,
  maxName
}: RangeFilterProps) => {
  const { t } = useTranslation();

  return (
    <RangeFilterContainer>
      <Input
        name={minName}
        type={InputTypeMap.range}
        id={minId}
        stat={minId}
        placeholder={t('search.form.from')}
      />
      <Separator />
      <Input
        name={maxName}
        type={InputTypeMap.range}
        id={maxId}
        stat={maxId}
        placeholder={t('search.form.to')}
      />
    </RangeFilterContainer>
  );
};
